/**
 * @typedef {(valuation: Valuation) => TableData} Callback
 * @typedef {{data: TableData, index?: string}} Response
 * @typedef {{name: Callback; email: Callback; phone: Callback; moverScore: Callback}} Callbacks
 * @typedef {import('../../../../shared/AgentService/ValuationData').ValuationResponse} Valuation
 * @typedef {import('./TableData').default} TableData
 */

import { currency } from '@mooveguru/js-utilities';
import { translate } from '../../../../Internationalization';
import formatDateForDisplay from '../../../../../utils/formatDateForDisplay';

/**
 * @param {Valuation[]} valuations
 * @param {Callbacks} callbacks
 * @returns {Response[][]}
 */
export default function getValuationTableData(valuations, callbacks) {
	return valuations.map((valuation, index) =>
		mapData(valuation, index, callbacks)
	);
}

/**
 * @param {Valuation} valuation
 * @param {number} index
 * @param {Callbacks} callbacks
 * @returns {Response[]}
 */
function mapData(valuation, index, callbacks) {
	const isInContacts = valuation.contact
		? translate('agent.pages.widgets.lead_generation.lead_table.yes')
		: translate('agent.pages.widgets.lead_generation.lead_table.no');

	return [
		tableCell(formatDateForDisplay(valuation.createdAt), index),
		tableCell(formatValuationAddress(valuation.address), index),
		tableCell(
			currency.convertNumberToCurrencyString(
				currency.convertCentsToDollars(valuation.value)
			),
			index
		),
		tableCell(callbacks.name(valuation), index),
		tableCell(callbacks.email(valuation), index),
		tableCell(callbacks.phone(valuation), index),
		tableCell(callbacks.moverScore(valuation), index),
		tableCell(isInContacts, index),
	];
}

/**
 * @param {TableData} data
 * @param {number} index
 * @returns {Response}
 */
function tableCell(data, index) {
	return { data, index: `valuation-${index}` };
}

/**
 * @param {Valuation['address']} address
 * @returns {string}
 */
function formatValuationAddress(address) {
	const streetAddress2 = address.streetAddress2
		? ` ${address.streetAddress2}`
		: '';

	return `${address.streetAddress1}${streetAddress2}, ${address.city}`.trim();
}
